/**
 * PATH: packages/job-hub/src/jobs/tabs/job-qa/JobQaAddQuotesSlot.tsx
 * FILE_ID: JOBHUB-QA-ADD-QUOTES-SLOT-001
 * PURPOSE: Wire attach hooks into the setup-card add-quotes leaf.
 */
import { useState } from 'react'
import { JobQaAddQuotes, type QuoteAttachDestination } from './JobQaAddQuotes'
import { useAttachQuotesToJob } from './useAttachQuotesToJob'
import { hideQaQuote } from './useQaJobQuotes'
import type { JobQaTabController } from './useJobQaTabController'

export function JobQaAddQuotesSlot({ controller }: { controller: JobQaTabController }) {
  const [destination, setDestination] = useState<QuoteAttachDestination>('this-job')
  const attach = useAttachQuotesToJob(controller.props.jobId, controller.props.orgId)
  return (
    <JobQaAddQuotes
      destination={destination}
      error={attach.error}
      listQDriveFiles={controller.api.listQDriveFiles}
      onDestinationChange={setDestination}
      onSearchCrm={attach.searchBuilderQuotes}
      onAttachBuilder={async (ids, includeFamily) => {
        await attach.attachBuilder({ builderQuoteIds: ids, includeFamily })
        await controller.refetchJobQuotes()
      }}
      onAttachFile={async (file) => {
        await attach.attachFile(file)
        await controller.refetchJobQuotes()
      }}
      onAttachQDrive={async (id) => {
        await attach.attachQDrive(id)
        await controller.refetchJobQuotes()
      }}
      loadRevisions={attach.loadRevisions}
      onHideBuilder={async (builderId) => {
        const sheet = controller.props.quotes.find((row) => String(row.quotebuilder_id ?? '') === builderId)
        if (!sheet) return
        await hideQaQuote(controller.client, controller.props.jobId, sheet.id)
        await controller.refetchJobQuotes()
      }}
      pending={attach.pending}
      canCreateJob={controller.canCreateQaJob !== false}
    />
  )
}
